export const UPDATE_CURRENT_INPUT = 'UPDATE_CURRENT_INPUT';
export const ALTER_DISABLED_STATUS_OF_INPUTBOX = "ALTER_DISABLED_STATUS_OF_INPUTBOX";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-inputbox/src/actions/actionTypes.ts